<template>
  <v-card class="mx-auto" max-width="344" hover>
    <v-img :src="foto" height="200px" cover @click="dialog = true"></v-img>

    <v-card-title>
      {{ nombre }}
    </v-card-title>

    <v-card-actions>
      <dialog-detail-component
        :id="id"
        :opciones="medidas"
        :colores="colores"
        :name="nombre"
      />

      <v-spacer></v-spacer>

      <v-btn
        :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        @click="show = !show"
      ></v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-card-text style="margin: 0; padding: 0">
          <v-expansion-panels variant="accordion">
            <v-expansion-panel title="Medidas (cm)" style="font-family: Arial, Helvetica, sans-serif; font-weight: 600;">
              <v-expansion-panel-text>
                <li class="medidasTxt" v-for="(medida, i) in medidas" :key="i">
                  {{ medida.medida }} :
                  <span style="color: green; font-weight: 600"
                    >$ {{ medida.precio }} MXN</span
                  >
                </li>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel title="Colores" style="font-family: Arial, Helvetica, sans-serif; font-weight: 600;">
              <v-expansion-panel-text>
                <li class="medidasTxt" v-for="(color, i) in colores" :key="i">
                  {{ color.color }} +
                  <span style="color: green; font-weight: 600"
                    >$ {{ color.costoAdicional }} MXN</span
                  >
                </li>
              </v-expansion-panel-text>
            </v-expansion-panel>
            <v-expansion-panel title="Extras" style="font-family: Arial, Helvetica, sans-serif; font-weight: 600;">
              <v-expansion-panel-text>
                <h5>Precio por Millar</h5>
                <li class="medidasTxt" v-for="(medida, i) in medidas" :key="i">
                  {{ medida.medida }}:
                  <span style="color: green; font-weight: 600">
                   $ {{ medida.precioMillar }} MXN
                  </span>
                </li>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>

  <v-dialog v-model="dialog" max-width="500px">
    <v-btn icon dark @click="dialog = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-img :src="foto" cover></v-img>
  </v-dialog>
</template>
<script>
import DialogDetailComponent from './DialogDetailComponent.vue';
export default {
  components: { DialogDetailComponent },
  props: {
    id: {
      type:String,
      default:''
    },
    nombre: {
      type:String,
      default:''
    },
    medidas: {
      type:Array,
      default:()=>[]
    },
    colores: {
      type:Array,
      default:()=>[]
    },
    foto: {
      type:String,
      default:''
    },
  },
  data: () => ({
    show: false,
    dialog: false,
  }),
};
</script>

<style scoped>
.medidasTxt {
  font-family: Arial, Helvetica, sans-serif;
  font-size: medium;
}
</style>
